import Button from "@imminently/decisively-ui/Button";
import Checkbox from "@imminently/decisively-ui/Checkbox";
import Chip from "@imminently/decisively-ui/Chip";
import SetupList from "@imminently/decisively-ui/SetupList";

import { ComponentPage, ComponentPreview, ComponentSection } from "../components/ComponentPage";

export function SetupListPage() {
  return <ComponentPage title="Setup List" description="Compact setup rows built from parts: an optional leading control, title, description, status, actions, and extra content.">
    <ComponentSection title="Required settings">
      <ComponentPreview className="w-full justify-stretch">
        <div className="w-full max-w-xl">
          <SetupList title="Required settings">
            <SetupList.Item>
              <SetupList.Item.Title>Saved destination</SetupList.Item.Title>
              <SetupList.Item.Status><Chip size="sm" variant="success" label="Ready" /></SetupList.Item.Status>
            </SetupList.Item>
            <SetupList.Item>
              <SetupList.Item.Title>Processing failures</SetupList.Item.Title>
              <SetupList.Item.Description>fileProcessing.failed</SetupList.Item.Description>
              <SetupList.Item.Status><Chip size="sm" variant="warning" label="Needs setup" /></SetupList.Item.Status>
            </SetupList.Item>
          </SetupList>
        </div>
      </ComponentPreview>
    </ComponentSection>
    <ComponentSection title="Action rows">
      <ComponentPreview className="w-full justify-stretch">
        <div className="w-full max-w-xl">
          <SetupList title="File routes" description="Connect incoming files to their mappings.">
            <SetupList.Item>
              <SetupList.Item.Title>Default contacts route</SetupList.Item.Title>
              <SetupList.Item.Description>Prefix: Default · Scope: contacts</SetupList.Item.Description>
              <SetupList.Item.Status><Chip size="sm" variant="warning" label="Needs setup" /></SetupList.Item.Status>
              <SetupList.Item.Action><Button size="sm" variant="outline" label="Apply route">Apply route</Button></SetupList.Item.Action>
            </SetupList.Item>
            <SetupList.Item>
              <SetupList.Item.Title>Files matching WP_*</SetupList.Item.Title>
              <SetupList.Item.Description>Prefix: WP_* · Scope: contacts</SetupList.Item.Description>
              <SetupList.Item.Status><Chip size="sm" variant="success" label="Ready" /></SetupList.Item.Status>
            </SetupList.Item>
          </SetupList>
        </div>
      </ComponentPreview>
    </ComponentSection>
    <ComponentSection title="Checkbox rows">
      <ComponentPreview className="w-full justify-stretch">
        <div className="w-full max-w-xl">
          <SetupList title="Decisively settings" hideTitle>
            <SetupList.Item>
              <SetupList.Item.Control><Checkbox id="setup-list-demo-derivation" defaultChecked /></SetupList.Item.Control>
              <SetupList.Item.Title htmlFor="setup-list-demo-derivation">Approver Derivation</SetupList.Item.Title>
              <SetupList.Item.Description>Whoever holds a position approves the positions under it.</SetupList.Item.Description>
              <SetupList.Item.Status><Chip size="sm" variant="success" label="Ready" /></SetupList.Item.Status>
            </SetupList.Item>
            <SetupList.Item>
              <SetupList.Item.Control><Checkbox id="setup-list-demo-recompute" /></SetupList.Item.Control>
              <SetupList.Item.Title htmlFor="setup-list-demo-recompute">Recompute on import</SetupList.Item.Title>
              <SetupList.Item.Status><Chip size="sm" variant="warning" label="Needs setup" /></SetupList.Item.Status>
            </SetupList.Item>
          </SetupList>
        </div>
      </ComponentPreview>
    </ComponentSection>
  </ComponentPage>;
}
